import { paragraphStyle as defaultParagraphStyle } from '../../utils/pdfConstants';

const YEAR_THRESHOLD = 1994;

const TEXT_BEFORE = `Kiinteistö on rakennettu ennen vuotta ${YEAR_THRESHOLD}, jolloin asbestia on voitu käyttää rakennusmateriaaleissa. Kohteessa on tällöin lakisääteinen tarve teettää asbestikartoitus ennen purkutöihin ryhtymistä.`;
const TEXT_AFTER  = `Kiinteistö on rakennettu vuoden ${YEAR_THRESHOLD} jälkeen, jolloin asbestia ei todennäköisesti ole käytetty rakennusmateriaaleissa. Lakisääteistä velvoitetta asbestikartoitukselle ei ole.`;

function extractEarliestYear(rakennusData) {
  const firstMain = rakennusData?.rakennukset_fulls?.find(r => r.isMainBuilding);
  const raw = firstMain?.rakennusvuosi ?? rakennusData?.rakennusvuosi;
  if (!raw) return NaN;
  const years = String(raw).split(/[\s,;/\n]+/).map(v => parseInt(v, 10)).filter(v => !isNaN(v));
  return years.length ? Math.min(...years) : NaN;
}

export function renderAsbestBlock({ block, content, rakennusData, paragraphStyle = defaultParagraphStyle }) {
  if (block?.data?.hiddenFromPdf) return;

  const year = extractEarliestYear(rakennusData);
  const hasYear = !isNaN(year);
  const isBefore = hasYear && year < YEAR_THRESHOLD;

  const text = hasYear
    ? (isBefore ? TEXT_BEFORE : TEXT_AFTER)
    : 'Kiinteistön rakennusvuosi ei ole tiedossa. Aseta rakennusvuosi kiinteistön perustiedoissa.';

  content.push({ text, ...paragraphStyle });
}
